
import { accMul, accAdd, accDiv, formatDegree2, GB18030StringZh } from './global.js';
import tdwtClass from '@/utils/analysis/tdwt.js';

class bd3Class {
    constructor(props) {
        // 紧急标识
        this.emergencyType = { 1: '应急搜救', 2: '标准定位报告', 3: '精密定位报告', };
        this.codingType = { 1: "汉字", 2: "代码", 3: "混编", 4: "压缩汉字", 5: "压缩代码" };

    }
    commandbd3(charCode) {
        const asteriskIndex = charCode.indexOf('*');
        const charDataArr = asteriskIndex !== -1 ? charCode.substring(0, asteriskIndex) : charCode;
        const instructArr = charDataArr.split(",");
        const agreementCode = instructArr[0];
        // let htmlReturn = `<div class="mb_10">输出：${charCode}</div> `;
        let htmlReturn = `<div class="mb_10"></div> `;
        switch (agreementCode) {
            case "$CCDTQ":
                htmlReturn += this.communicationCCDTQ(charDataArr);
                break;
            case "$CCEPQ":
                htmlReturn += this.communicationCCEPQ(charDataArr);
                break;
            case "$CCGBQ":
                htmlReturn += this.communicationCCGBQ(charDataArr);
                break;
            case "$CCICR":
                htmlReturn += this.communicationCCICR(charDataArr);
                break;
            case "$CCOFQ":
                htmlReturn += this.communicationCCOFQ(charDataArr);
                break;
            case "$CCRMO":
                htmlReturn += this.communicationCCRMO(charDataArr);
                break;
            case "$BDEPI":
                htmlReturn += this.communicationBDEPI(charDataArr);
                break;
            case "$BDFKl":
                htmlReturn += this.communicationBDFKl(charDataArr);
                break;
            case "$BDGBI":
                htmlReturn += this.communicationBDGBI(charDataArr);
                break;
            case "$BDICP":
                htmlReturn += this.communicationBDICP(charDataArr);
                break;
            case "$BDICZ":
                htmlReturn += this.communicationBDICZ(charDataArr);
                break;
            case "$BDPWI":
                htmlReturn += this.communicationBDPWI(charDataArr);
                break;
            case "$BDGGA":
            case "$GPGGA":
            case "$GLGGA":
            case "$GAGGA":
                htmlReturn += this.communicationBDGGA(charDataArr);
                break;
            case "$BDGLL":
            case "$GPGLL":
            case "$GLGLL":
            case "$GAGLL":
                htmlReturn += this.communicationBDGLL(charDataArr);
                break;
            case "$BDGSA":
            case "$GPGSA":
            case "$GBGSA":
            case "$GSGSA":
                htmlReturn += this.communicationBDGSA(charDataArr);
                break;
            case "$BDGSV":
                htmlReturn += this.communicationBDGSV(charDataArr);
                break;
            case "$BDRMC":
                htmlReturn += this.communicationBDRMC(charDataArr);
                break;
            case "$BDVTG":
                htmlReturn += this.communicationBDVTG(charDataArr);
                break;
            case "$BDZDA":
            case "$CCZDA":
            case "$GPZDA":
            case "$GNZDA":
                htmlReturn += this.communicationBDZDA(charDataArr);
                break;
            case "$CCTBQ":
                htmlReturn += this.communicationCCTBQ(charDataArr);
                break;
            // 北二
            case "$BDBSI":
                htmlReturn += this.communicationBDBSI(charDataArr);
                break;
            case "$BDDWR":
                htmlReturn += this.communicationBDDWR(charDataArr);
                break;
            case "$BDFKI":
                htmlReturn += this.communicationBDFKI(charDataArr);
                break;
            case "$BDHZR":
                htmlReturn += this.communicationBDHZR(charDataArr);
                break;
            case "$BDICI":
                htmlReturn += this.communicationBDICI(charDataArr);
                break;
            // case "$BDICZ":
            //     htmlReturn += this.communicationBDICZ2(charDataArr);
            //     break;
            case "$BDTXR":
                htmlReturn += this.communicationBDTXR(charDataArr);
                break;
            case "$CCTXA":
                htmlReturn += this.communicationCCTXA(charDataArr);
                break;
            case "$BDWAA":
            case "$CCWAA":
                htmlReturn += this.communicationBDWAACCWAA(charDataArr);
                break;
            case "$BDTCI":
                htmlReturn += this.communicationBDTCI(charDataArr);
                break;
            default:
                alert("数据错误或未记录该命令");
                break;
        }
        return htmlReturn;

        // bd3 与 bd2 存在同样的指令：   ICZ
        //  bd2 缺指令：   VRX  ZDX
    }
    /**
    *@description: 处理经纬度 
    *@param {*}  values
    *@param {*}  loctype 经度 longitude  纬度 latitude
    */
    setPositionLog(values, loctype) {
        if (loctype == 'longitude') {
            // const agreement0 = values.substr(0, 2);
            // const agreement1 = values.substr(2, 2);
            // const agreement2 = values.substr(5);
            // const Longitude = `${+agreement0}.${+agreement1}${+agreement2}`
            // return formatDegree2(Longitude, 2)
            const agreement0 = values.substr(0, 2);
            const agreement1 = values.substr(2);
            const Longitude = `${accAdd(+agreement0, accDiv(agreement1, 60))}`
            return formatDegree2(Longitude, 2)
        } else {
            // const agreement0 = values.substr(0, 3);
            // const agreement1 = values.substr(3, 2);
            // const agreement2 = values.substr(6);
            // const Latitude = `${+agreement0}.${+agreement1}${+agreement2}`
            // return formatDegree2(Latitude, 2)
            const agreement0 = values.substr(0, 3);
            const agreement1 = values.substr(3);
            const Latitude = `${accAdd(+agreement0, accDiv(agreement1, 60))}`
            return formatDegree2(Latitude, 2)
        }
    }
    /**
    *@description: 处理时间
    *@param {*}  timeVal
    */
    setTimes(timeVal) {
        const agreement0 = timeVal.substr(0, 2) || '00';
        const agreement1 = timeVal.substr(2, 2) || '00';
        const agreement2 = timeVal.substr(4, 2) || '00';
        const tiem = `${agreement0}:${agreement1}:${agreement2}`
        return tiem;
    }
    /**
    *@description: DTQ 功能描述:定时申请，输入语句。用户向设备发送定时申请。
    *@param {*}  例子 $CCDTQ,x*hh<CR><LF>
    */
    communicationCCDTQ(charCode) {
        const instructArr = charCode.split(",");
        const code1 = instructArr[1];
        const bgType = { 1: "无位置", 2: "有位置" }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：定时申请，输入语句。用户向设备发送定时申请。</div>`;
        htmlAgreement += `<div>报告模式：${bgType[code1] || '取值范围错误！！！'}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description: EPQ 功能描述:应急搜救和定位报告申请，输入语句，用户发送定位报告或应急搜救申请。
    *@param {*}  格式:$CCEPQ,X.X,X,X,X.X_X,X,X,X.X,X,x.x*hh <CR><LF>
    *@param {*}  格式:$CCEPQ,123456,1,1,3,2,15,3,0,50,5,4.0*hh <CR><LF>
    */
    communicationCCEPQ(charCode) {
        const instructArr = charCode.split(",");
        const code1 = instructArr[1];
        const code2 = instructArr[2];
        const code3 = instructArr[3];
        const code4 = instructArr[4];
        const code5 = instructArr[5];
        const code6 = instructArr[6];
        const code7 = instructArr[7];
        const code8 = instructArr[8];
        const code9 = instructArr[9];
        const code10 = instructArr[10];
        const code11 = instructArr[11];//BCD码，见注4。

        const bgType = {
            1: 'RDSS定位报告(无测高)',
            2: 'RDSS定位报告(有测高)',
            3: '广义RDSS定位报告',
            4: '普通位置报告,无需增加手动经纬高协议,终端可以通过 RNSS定位自动添加本地位置',
            5: '自适应,根据场景发送定位报告',
        }
        const frequencyType = {
            0: 'Lf0北斗二号RDSS入站频点,自适应频点入站',
            1: 'Lf1北斗三号民用入站频点',
            2: 'Lf2北斗三号民用入站频点',
            3: 'Lf3',
            4: 'Lf4全球报文通信业务频点',
            5: 'Lf5;',
        }
        const searchType = { 1: '呼救申请', 2: '呼救取消', 3: '前向身份鉴别', }

        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：应急搜救和定位报告申请，输入语句，用户发送定位报告或应急搜救申请。</div>`;
        htmlAgreement += `<div>收信方ID：${code1}</div>`;
        htmlAgreement += `<div>定位报告模式：${bgType[code2] || `注1:如果定位报告模式为普通位置报告时，6,7均置空或为0:`}</div>`;
        htmlAgreement += `<div>入站频点：${frequencyType[code3] || ''}</div>`;
        htmlAgreement += `<div>入站速率：${code4}档速率。</div>`;
        htmlAgreement += `<div>紧急标识：${this.emergencyType[code5] || ''}</div>`;
        htmlAgreement += `<div>高程值：${code6}米</div>`;
        htmlAgreement += `<div>搜救类型：${searchType[code7] || ''}</div>`;
        htmlAgreement += `<div>频度：${code8 == 0 ? '单次' : code8}</div>`;
        htmlAgreement += `<div>入站功率：${code9}</div>`;
        htmlAgreement += `<div>搜救业务数据或者状态数据长度:${code10}</div>`;
        htmlAgreement += `<div>搜救业务数据状态数据:${code11}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:GBQ 功能描述:组群申请，输入语句。用户通过设备向主控站发送组群等相应申请。
    *@param {*}  格式:$CCGBQ,XX,X.X,XXX,X...X,X.x*hh <CR><LF>
    *@param {*}  格式:$CCGBQ,12,1,321,3,01,02,03*21
    */
    communicationCCGBQ(charCode) {
        const instructArr = charCode.split(",");
        const code1 = instructArr[1];
        const code2 = instructArr[2];
        const code3 = instructArr[3];
        const code4 = instructArr[4];
        const code5 = instructArr[5];
        const bgType = {
            1: "编组权限调整",
            2: "建组申请",
            3: "建组确认",
            4: "增加组员申请",
            5: "增员应答",
            6: "删除组员申请",
            7: "删员应答",
            8: "线下增员申请",
            9: "退组申请",
            10: "撤组申请",
            11: "撤组应答",
            12: "用户查询",
        }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：组群申请，输入语句。用户通过设备向主控站发送组群等相应申请。</div>`;
        htmlAgreement += `<div>类别：${bgType[code1] || ''}</div>`;
        if (code1 != 2) {
            htmlAgreement += `<div>${code1 == 1 ? '目的地址' : '编组地址'}：${code1 == 2 ? '' : code2}</div>`;
        }
        htmlAgreement += `<div>编组序号：${code3}</div>`;
        htmlAgreement += `<div>个数：${+code4}</div>`;
        for (let index = 0; index < +code4; index++) {
            const start = 5 + index
            htmlAgreement += `<div class="ml_20">  成员ID：${instructArr[start]}</div>`;
        }
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:ICR 功能描述:本机及IC模块信息查询。输入语句，读取北斗三号用户机设备IC模块信息，编组信息，或指挥型终端检测下属用户信息
    *@param {*}  该信息以ICP、ICG、ICZ语句进行输出。格式: $CCICR,x,xx*hh<CR><LF>
    *@param {*}  格式:$CCICR,2,32*hh
    */
    communicationCCICR(charCode) {
        const instructArr = charCode.split(",");
        const code1 = instructArr[1];
        const code2 = instructArr[2];
        const bgType = {
            0: "检测本机IC模块信息",
            1: "检测本机编组信息",
            2: "检测具备指挥功能终端的下属用户信息",
            3: "检测IC模块工作模式",
        }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：本机及IC模块信息查询。输入语句，读取北斗三号用户机设备IC模块信息，编组信息，或指挥型终端检测下属用户信息。</div>`;
        htmlAgreement += `<div>指令类型：${bgType[code1] || ''}</div>`;
        htmlAgreement += `<div>下属用户信息帧：${code2}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:OFQ 功能描述:开关机报告申请，输入语句。用户通过设备向总站发送开关机报告申请。
    *@param {*}   格式: $CCOFQ,x*hh <CR><LF>
    *@param {*}   格式: $CCOFQ,2,0*hh
    */
    communicationCCOFQ(charCode) {
        const instructArr = charCode.split(",");
        const code1 = instructArr[1];
        const code2 = instructArr[2];
        const bgType = {
            1: "开机报告",
            2: "关机报告",
            3: "状态报告",
        }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：开关机报告申请，输入语句。用户通过设备向总站发送开关机报告申请。</div>`;
        htmlAgreement += `<div>报告类型：${bgType[code1] || ''}</div>`;
        htmlAgreement += `<div>频点：Lf${code2}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:RMO 功能描述:输入语句。输出语句激活，设定向己方输出或停止输出参数语句。格式:$--RMO,ccc,x,x.x*hh<CR><LF>
    *@param {*}   格式: 格式:$--RMO,ccc,x,x.x*hh<CR><LF>
    *@param {*}   格式: $CCRMO,123456,2,0*hh
    */
    communicationCCRMO(charCode) {
        const instructArr = charCode.split(",");
        const code1 = instructArr[1];
        const code2 = instructArr[2];
        const code3 = instructArr[3];
        const bgType = {
            1: "关闭指定语句",
            2: "打开指定语句",
            3: "关闭全部语句",
            4: "打开全部语句",
        }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：输入语句。输出语句激活，设定向己方输出或停止输出参数语句。</div>`;
        htmlAgreement += `<div>目标语句：${code1}</div>`;
        htmlAgreement += `<div>打开模式：${bgType[code2] || ''}</div>`;
        htmlAgreement += `<div>目标语句输出频度：${code3 == 0 ? '单次' : code3}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:EPI 功能描述:应急搜救和定位报告信息，输出语句，终端接收到应急搜救或定位报告信息。
    *@param {*}   格式: $BDEPI,x.X,XX,X,x,x,hhmmss.ss,yyyYy-yy,c,.III.Il,c,.x.X.C,X.X,C,XX,X,X,X.x,C-c*hh<CR><LF>
    *@param {*}   格式: $BDEPI,44207733,4207748,4,2,2,092312.01,11323.12,E,2312.02,N,12,M,01,M,1,2,3,4,12,123*12
    */
    communicationBDEPI(charCode) {
        const instructArr = charCode.split(",");
        const code1 = instructArr[1];
        const code2 = instructArr[2];
        const code3 = instructArr[3];
        const code4 = instructArr[4];
        const code5 = instructArr[5];
        const code6 = instructArr[6];
        const code7 = instructArr[7];
        const code8 = instructArr[8];
        const code9 = instructArr[9];
        const code10 = instructArr[10];
        const code11 = instructArr[11];
        const code12 = instructArr[12];
        const code13 = instructArr[13];
        const code14 = instructArr[14];
        const code15 = instructArr[15];
        const code16 = instructArr[16];
        const code17 = instructArr[17];
        const code18 = instructArr[18];
        const code19 = instructArr[19];
        const code20 = instructArr[20];

        const bgType = { 1: "S1", 2: "S2C", 3: "", 4: "B2b", }
        const locType = { 1: "RDSS定位报告", 2: "广义 RDSS定位报告", 3: "普通位置报告", 4: "搜救中心指示代码(仅当紧急标识为1时才有)", }
        const saveType = { 1: "呼救回执", 2: "入站发射控制指令（含频度控制)", 3: "返向身份鉴别", 4: "呼救唤醒", }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：应急搜救和定位报告信息，输出语句，终端接收到应急搜救或定位报告信息。</div>`;
        htmlAgreement += `<div>发信方ID：${code1}</div>`;
        htmlAgreement += `<div>收信方ID：${code2}</div>`;
        htmlAgreement += `<div>接收频点：${bgType[code3] || ''}</div>`;
        htmlAgreement += `<div>紧急标识：${this.emergencyType[code4] || ''}</div>`;
        htmlAgreement += `<div>定位报告模式：${locType[code5] || ''}</div>`;
        htmlAgreement += `<div>时间：${this.setTimes(code6)} </div>`;
        htmlAgreement += `<div>经度：${this.setPositionLog(code7, 'latitude')}  ${code8}</div>`;
        htmlAgreement += `<div>纬度： ${this.setPositionLog(code9, 'longitude')} ${code10}</div>`;
        htmlAgreement += `<div>高程：${code11} ${code12}</div>`;
        htmlAgreement += `<div>高程异常：${code13} ${code14}</div>`;
        htmlAgreement += `<div>精度指示：${code15} </div>`;
        htmlAgreement += `<div>多值解：${code16}</div>`;
        htmlAgreement += `<div>搜救业务子类型：${code17}</div>`;
        htmlAgreement += `<div>搜救中心指示类型：${saveType[code18] || ''}</div>`;
        htmlAgreement += `<div>搜救业务数据或者状态数据长度：${code19}</div>`;
        htmlAgreement += `<div>搜救业务数据/状态数据：${code20}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /** 
    *@description:FKl 功能描述:发射申请反馈状态，输出语句。设备向用户反馈入站发射类型，成功与否状态及原因等。
    *@param {*}   格式: $BDFKl, hhmmss,aaa,c,x,xxx *hh <CR><LF>
    *@param {*}   格式: $BDFKl,10:10:10,TCQ,N,1,60*hh
    */
    communicationBDFKl(charCode) {
        const instructArr = charCode.split(",");
        const code1 = instructArr[1];
        const code2 = instructArr[2];
        const code3 = instructArr[3];
        const code4 = instructArr[4];
        const code5 = instructArr[5];
        const bgType = {
            'EPQ': "应急搜救与定位报告",
            'TCQ': "报文通信申请",
            'QRQ': "查询功能",
            'DTQ': "定时申请",
            'OFQ': "开关机报告",
            'MSQ': "静默申请",
            'GBQ': "建组申请",
        }
        const errType = {
            '1': "频率未到",
            '2': "报文通信申请",
            '3': "发射抑制",
            '4': "功率未锁定",
            '5': "未检测到IC模块信息",
            '6': "权限不足",
        }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：发射申请反馈状态，输出语句。设备向用户反馈入站发射类型，成功与否状态及原因等。</div>`;
        htmlAgreement += `<div>目标语句：${code1}</div>`;
        htmlAgreement += `<div>打开模式：${bgType[code2] || ''}</div>`;
        htmlAgreement += `<div>发射情况：${code3 == 'Y' ? '发射成功' : '发射失败'}</div>`;
        htmlAgreement += `<div>失败原因：${errType[code4] || ''}</div>`;
        htmlAgreement += `<div>剩余时间：${code3 == 'Y' ? this.setTimes(code5) : ''}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /** 
    *@description:GBI 功能描述:组群通知信息，输出语句。主控站向设备发送相应组群通知信息。
    *@param {*}   格式: $BDGBI, x,X0XCx,X.x,X.X.,XXX.,X.X.....x* hh <CR><LF>
    *@param {*}   格式: $BDGBI,9,121,32,23,06,01,02,03,04,05,06*21
    */
    communicationBDGBI(charCode) {
        const instructArr = charCode.split(",");
        const code1 = instructArr[1];
        const code2 = instructArr[2];
        const code3 = instructArr[3];
        const code4 = instructArr[4];
        const code5 = instructArr[5];
        const code6 = instructArr[6];
        const bgType = {
            1: "建组通知",
            2: "增加通知",
            3: "组播删除通知",
            4: "点播删除通知",
            5: "组播退组通知",
            6: "点播退组通知",
            7: "组播撤组通知",
            8: "点播撤组通知",
            9: "用户查询结果",
        }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：组群通知信息，输出语句。主控站向设备发送相应组群通知信息。</div>`;
        htmlAgreement += `<div>类别：${bgType[code1] || ''}</div>`;
        htmlAgreement += `<div>编组序号：${code2}</div>`;
        htmlAgreement += `<div>编组地址：${code3}</div>`;
        htmlAgreement += `<div>组长地址：${code4}</div>`;
        htmlAgreement += `<div>个数：${+code5}</div>`;
        for (let index = 0; index < +code5; index++) {
            const start = 6 + index
            htmlAgreement += `<div class="ml_20">成员ID：${instructArr[start]}</div>`;
        }
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /** 
    *@description:ICP 功能描述:IC模块信息查询，输出语句。终端输出本机IC模块基本参数。
    *@param {*}   格式: $BDICP,x.X,×.X,X,X,X,CyX,C;X,X,X,憧,×,×;X)X,X,XX.X,X,..X,X.X,X.x,x.x*hh<CR><LF>
    *@param {*}   格式: $BDICP,123456,654321,1,3,1,E,1,Y,1,1,0,1,1,60,3,1,1,60,3,5,10,20,30
    */
    communicationBDICP(charCode) {
        const instructArr = charCode.split(",");
        const bgType = { 1: "北斗一号用户", 2: "北斗二号用户", 3: "北斗三号用户", }
        const addrType = { 1: "指挥型", 2: "兼收型", 3: "普通型", }
        const userType = { 1: "特级", 2: "高级", 3: "普通", }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：IC模块信息查询，输出语句。终端输出本机IC模块基本参数。</div>`;
        htmlAgreement += `<div>用户地址(ID号)：${instructArr[1]}</div>`;
        htmlAgreement += `<div>通播地址：${instructArr[2]}</div>`;
        htmlAgreement += `<div>授启类型：${instructArr[3] == '0' ? '非授启' : instructArr[3] == '1' ? '授启' : ''}</div>`;
        htmlAgreement += `<div>用户标识：${bgType[instructArr[4]] || ''}</div>`;
        htmlAgreement += `<div>启用/暂停服务标记：${instructArr[5] == '0' ? '服务启用' : instructArr[5] == '1' ? '服务暂停' : ''}</div>`;
        htmlAgreement += `<div>保密标识：${instructArr[6] == 'E' ? '加密' : instructArr[6] == 'N' ? '非密' : ''}</div>`;
        htmlAgreement += `<div>终端类型：${addrType[instructArr[7]] || ''}</div>`;
        htmlAgreement += `<div>搜救标识：${instructArr[8] == 'Y' ? '搜救用户' : instructArr[8] == 'N' ? '非搜救用户' : ''}</div>`;
        htmlAgreement += `<div>军/民标识：${instructArr[9] == '0' ? '军用' : instructArr[9] == '1' ? '民用' : ''}</div>`;
        htmlAgreement += `<div>军民交互权限：${instructArr[10] == '0' ? '无此权限' : instructArr[10] == '1' ? '有此权限' : ''}</div>`;
        htmlAgreement += `<div>我国/友国标识：${instructArr[11] == '0' ? '我国' : instructArr[11] == '1' ? '友国' : ''}</div>`;
        htmlAgreement += `<div>用户优先级：${userType[instructArr[12]] || ''}</div>`;
        htmlAgreement += `<div>RD区域服务能力标识：${instructArr[13] == '0' ? '无此权限' : instructArr[13] == '1' ? '有此权限' : ''}</div>`;
        htmlAgreement += `<div>RDSS服务频度：${instructArr[14]}秒</div>`;
        htmlAgreement += `<div>RDSS通信长度等级：${instructArr[15]}</div>`;
        htmlAgreement += `<div>全球标识：${instructArr[16]}</div>`;
        htmlAgreement += `<div>全球短报文交互权限：${instructArr[17] == '0' ? '无此权限' : instructArr[17] == '1' ? '有此权限' : ''}</div>`;
        htmlAgreement += `<div>全球短报文服务频度：${instructArr[18]}秒</div>`;
        htmlAgreement += `<div>全球短报文通信长度等级：${instructArr[19]}</div>`;
        htmlAgreement += `<div>下属用户数：${instructArr[20]}</div>`;
        htmlAgreement += `<div>编组权限：${instructArr[21]}</div>`;
        htmlAgreement += `<div>自建组数：${instructArr[22]}</div>`;
        htmlAgreement += `<div>加入组数量：${instructArr[23]}</div>`;


        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /** 
    *@description:ICZ 功能描述:下属用户查询，输出语句。指挥型用户输出下属用户信息。除最后一条下属信息外，之前每条语句必须传满40个用户ID。
    *@param {*}   格式: 格式:$BDICZ,XX,x.x,C......x*hh<CR><LF>
    *@param {*}   格式: $BDICZ,2,11,Y,12,N,0*hh
    */
    communicationBDICZ(charCode) {
        const instructArr = charCode.split(",");
        const code1 = instructArr[1];
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：下属用户查询，输出语句。指挥型用户输出下属用户信息。</div>`;
        htmlAgreement += `<div>下属用户数：${code1}</div>`;
        for (let index = 0; index < code1; index++) {
            const start = 2 + accMul(index, 2);
            const end = start + 1;
            htmlAgreement += `<div class=" ml_20">下属用户ID号：${instructArr[start]};  是否三代用户：${instructArr[end] == 'Y' ? '三号用户' : instructArr[end] == 'N' ? '二号用户' : instructArr[end]}</div>`;
        }
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /** 
    *@description:PWI 功能描述:波束跟踪状态，输出语句。设备向用户上报当前出站波束跟踪状态。
    *@param {*}   格式: $BDPWI,hhmmss.ss,XX,XX,XX,XX,--XX,XX,.XXK,KX,XX,XX,XX,XX--XX,Xx.,xx,xx*hh<CR><LF>
    *@param {*}   格式: $BDPWI,032846.74,05,02,44,44,03,55,55,05,10,10,08,46,46,09,47,47,08,03,38,38,04,38,38,05,38,38,
    */
    communicationBDPWI(charCode) {
        const instructArr = charCode.split(",");
        const code1 = instructArr[1];
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：波束跟踪状态，输出语句。设备向用户上报当前出站波束跟踪状态。</div>`;
        htmlAgreement += `<div>时间：${this.setTimes(code1)}</div>`;
        const RDSSNumber = instructArr[2];
        if (RDSSNumber > 0) {
            htmlAgreement += `<div>RDSS旧体制出站波束锁定数量：${RDSSNumber}</div>`;
        }
        for (let index = 0; index < RDSSNumber; index++) {
            const start = 3 + accMul(index, 3);
            htmlAgreement += `<div class="ml_20">
            <span>第${index + 1}个</span>
            <span class="ml_20">出站波束编号：${instructArr[start]}</span> 
            <span class="ml_20">S1I支路载噪比：${instructArr[start + 1] == 0 ? '未锁定' : `${instructArr[start + 1]}dBHz`};</span> 
            <span class="ml_20">S1Q支路载噪比：${instructArr[start + 2] == 0 ? '未锁定' : `${instructArr[start + 2]}dBHz`};</span> 
            </div>`;
        }
        const endIndex = accMul(RDSSNumber, 3) + 3;
        const RDSSNewNumber = instructArr[endIndex];
        if (RDSSNewNumber > 0) {
            htmlAgreement += `<div>RDSS新体制出站波束锁定数量：${RDSSNewNumber}</div>`;
        }
        for (let index = 0; index < RDSSNewNumber; index++) {
            const start = endIndex + 1 + accMul(index, 3);
            if (instructArr.length > start + 1) {
                htmlAgreement += `<div class="ml_20">
                <span>第${index + 1}个</span>
                <span class="ml_20">出站波束编号：${instructArr[start]}</span>
                <span class="ml_20">S2C_d支路载噪比：${instructArr[start + 1] == 0 ? '未锁定' : `${instructArr[start + 1]}dBHz`};</span> 
                <span class="ml_20">S2C_p支路载噪比：${instructArr[start + 2] == 0 ? '未锁定' : `${instructArr[start + 2]}dBHz`};</span> 
                </div>`;
            }
        }
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:GGA 功能描述:输出语句。描述定位数据，本语句包含与接收机定位、授时相关的数据。如果只将BDS、GPS、GLONASS、Galieo等卫星用于位置解算，传送标示符为BD、GP、GL、GA 等，如果使用了多个系统的卫星取得位置解算，传送标示符为GN。语句格式说明见表5-6。
    *@param {*}   格式: $--GGA,hhmmss.ss,I ,a,yyYyYy.yY,a,X,XXK,X.XX.X,U,x.x,U ,xX0Ox,X.x,x.x*hh<CR><LF>
    *@param {*}   格式: $BDGGA,082312.23,2313.23,N,11323.23,E,2,12,2.5,34,M,23,M,2312,2.9,89*32
    */
    communicationBDGGA(charCode) {
        const instructArr = charCode.split(",");
        const bgType = { 0: "定位数据无效", 1: "单点定位，定位有效", 2: "伪距差分定位，定位有效", 3: "双频定位，定位有效", 4: "RTK定位，固定解", 5: "RTK定位，浮点解", 6: "SBAS定位，定位有效", 7: "PPP定位，定位有效（BD3定位模式)", }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：输出语句。描述定位数据，本语句包含与接收机定位、授时相关的数据。如果只将BDS、GPS、GLONASS、Galieo等卫星用于位置解算，传送标示符为BD、GP、GL、GA</div>`;
        htmlAgreement += `<div>定位时间：${this.setTimes(instructArr[1])}</div>`;
        htmlAgreement += `<div>纬度： ${this.setPositionLog(instructArr[2], 'longitude')}  ${instructArr[3]}</div>`;
        htmlAgreement += `<div>经度： ${this.setPositionLog(instructArr[4], 'latitude')}  ${instructArr[5]}</div>`;
        htmlAgreement += `<div>状态指示：${bgType[instructArr[6]] || ''}</div>`;
        htmlAgreement += `<div>参与定位卫星数：${instructArr[7]}</div>`;
        htmlAgreement += `<div>HDOP值：${instructArr[8]}</div>`;
        htmlAgreement += `<div>天线大地高：${instructArr[9]} ${instructArr[10]}</div>`;
        htmlAgreement += `<div>CGS-2000高程异常：${instructArr[11]}  ${instructArr[12]}</div>`;
        htmlAgreement += `<div>差分数据龄期：${instructArr[13]}</div>`;
        htmlAgreement += `<div>差分站台ID号：${instructArr[14]}</div>`;
        htmlAgreement += `<div>VDOP值：${instructArr[15]}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:GLL 功能描述:输出语句。大地坐标定位信息，载体的纬度、经度、定位时间与状态。如果终端通过 BDS、GPS、GLONASS、Galieo 等卫星用于位置解算，传送标识符为 BD、GP、GL、GA等，如果使用了多个系统的卫星取得位置解算，传送标识符用GN。
    *@param {*}   格式: $--GLL,IIIL.Il,a,yyyyy.vyy,a,hhmmss.ss,A,x*hh<CR><LF>
    *@param {*}   格式: $BDGLL,33,N,113,W,10:10:10,A,3,2
    */
    communicationBDGLL(charCode) {
        const instructArr = charCode.split(",");
        const dataType = { 'A': "数据有效", 'V': "数据无效", }
        const bgType = { 0: "自动模式", 1: "伪距差分模式", 2: "估算（航位推算）模式", 3: "手动输入模式", 4: "模拟器模式", 5: "RTK定位，固定解", 6: "SBAS模式", 7: "PPP模式", }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：输出语句。大地坐标定位信息，载体的纬度、经度、定位时间与状态。如果终端通过 BDS、GPS、GLONASS、Galieo 等卫星用于位置解算，传送标识符为 BD、GP、GL、GA等，如果使用了多个系统的卫星取得位置解算，传送标识符用GN。</div>`;
        htmlAgreement += `<div>纬度：${this.setPositionLog(instructArr[1], 'longitude')}${instructArr[2]}</div>`;
        htmlAgreement += `<div>经度： ${this.setPositionLog(instructArr[3], 'latitude')}${instructArr[4]}</div>`;
        htmlAgreement += `<div>定位时间：${this.setTimes(instructArr[5])}</div>`;
        htmlAgreement += `<div>数据状态：${dataType[instructArr[6]] || ''}</div>`;
        htmlAgreement += `<div>模式指示：${bgType[instructArr[7]] || ''}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:GSA 功能描述:输出语句。本语句包含终端工作模式、GSA 语句报告的导航解算中用到的卫星以及精度因子（DOP）的值。当只用BDS、GPS、GLONASS、Galieo等卫星系统解算定位数据时，则标识符相应地使用BD、GP、GL、GA 等等。当综合运用 BDS、GPS、GLONASS、Galieo等获得位置解算时，会产生多条GSA语句，每一条GSA语句应用GN作为标识符，以表示综合解算中用到的卫星，且每条都有用于位置解的组合卫星系统的 PDOP、HDOP、VDOP和TDOP。
    *@param {*}   格式:$--GSA,a,X,X.X,X0X....XOX.,‰.X,X.X_X.x*hh<CR><LF>
    *@param {*}   格式: $BDGSA,A,2,3,10,20,30,1,2,3,4*hh
    */
    communicationBDGSA(charCode) {
        const instructArr = charCode.split(",");
        const dataType = { 'M': "手动,强制用于2D 或3D模式;", 'A': "自动,允许2D/3D自动变换;", }
        const bgType = { 1: "未定位", 2: "2D", 3: "3D", }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：输出语句。本语句包含终端工作模式、GSA 语句报告的导航解算中用到的卫星以及精度因子（DOP）的值。当只用BDS、GPS、GLONASS、Galieo等卫星系统解算定位数据时，则标识符相应地使用BD、GP、GL、GA 等等。当综合运用 BDS、GPS、GLONASS、Galieo等获得位置解算时，会产生多条GSA语句，每一条GSA语句应用GN作为标识符，以表示综合解算中用到的卫星，且每条都有用于位置解的组合卫星系统的 PDOP、HDOP、VDOP和TDOP。</div>`;
        htmlAgreement += `<div>模式指示：${dataType[instructArr[1]] || ''}</div>`;
        htmlAgreement += `<div>选用模式：${bgType[instructArr[2]] || ''}</div>`;
        htmlAgreement += `<div>卫星颗数：${instructArr[3]}</div>`;
        const startIndex = instructArr[3];
        const end = accAdd(startIndex, 3)
        for (let index = 0; index < startIndex; index++) {
            const start = index + 4;
            htmlAgreement += `<div>第${index + 1}颗卫星号：${instructArr[start]}</div>`;
        }
        htmlAgreement += `<div>HDOP值：${instructArr[end + 1]}</div>`;
        htmlAgreement += `<div>VDOP值：${instructArr[end + 2]}</div>`;
        htmlAgreement += `<div>TDOP值：${instructArr[end + 3]}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:GSV 功能描述:可视的卫星状态，包括:可视的卫星数、卫星标识号、仰角、方位角及信噪比（SNR〉值。如果可以看到多颗BD、GPS、GLONASS等卫星，分别使用GSV语句，用发射器标识符BD表示看到的BD卫星，用GP表示看到的GPS 卫星，用GL表示看到的GLONASS卫星,等等。GN标识符不应当与这条语句一起使用。
    *@param {*}   格式:$--GSV,x.x,X.x,X0X,X0CK,XX,X.X,X..X......hh<CR><LF>
    *@param {*}   格式: $BDGSV,1,2,3,10,30,60,101,20,45,90,102,20,45,90,102,1
    */
    communicationBDGSV(charCode) {
        const instructArr = charCode.split(",");
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：可视的卫星状态，包括:可视的卫星数、卫星标识号、仰角、方位角及信噪比（SNR〉值。如果可以看到多颗BD、GPS、GLONASS等卫星，分别使用GSV语句，用发射器标识符BD表示看到的BD卫星，用GP表示看到的GPS 卫星，用GL表示看到的GLONASS卫星,等等。GN标识符不应当与这条语句一起使用。</div>`;
        htmlAgreement += `<div>GSV语句总数：${instructArr[1]}</div>`;
        htmlAgreement += `<div>当前GSV语句序号：${instructArr[2]}</div>`;
        htmlAgreement += `<div>视野内卫星数：${instructArr[3]}</div>`;
        const startIndex = instructArr[3];
        // const end = accAdd(accMul(startIndex, 4), 3)
        for (let index = 0; index < startIndex; index++) {
            // const start = index + 3;
            const start = 3 + accMul(index, 4);
            if (start + 4 < instructArr.length) {
                htmlAgreement += `<div class="ml_20">
                <span>序号${index + 1}</span>
                <span class="ml_20">卫星号：${instructArr[start + 1]}</span> 
                <span class="ml_20">卫星仰角：${instructArr[start + 2]}度</span> 
                <span class="ml_20">卫星方位角：${instructArr[start + 3]}度</span> 
                <span class="ml_20">信噪比：${instructArr[start + 4]}dB·Hz</span> 
                </div>`;
            }
        }
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:RMC 功能描述:输出语句。推荐最简导航传输数据。
    *@param {*}  格式:$--RMC,hhmmss.ss,AIII.Il,a,yyyyy.yy,a,X.X.,x.x,ddmmyy,x.x,a,a*hh<CR><LF>
    *@param {*}   格式: $BDRMC,091223.23,A,2312.34,N,11323.02,E,23,2.33,12032024,56,E,N*21
    */
    communicationBDRMC(charCode) {
        const instructArr = charCode.split(",");
        const locType = { 'A': "有效定位", 'V': "无效定位" }
        const bgType = { 'A': "单点定位", 'D': "伪距差分", 'E': "估算", 'R': "RTK固定解", 'S': "SBAS定位", 'P': "PPP定位", 'N': "无效", }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：输出语句。推荐最简导航传输数据。</div>`;
        htmlAgreement += `<div>时间：${this.setTimes(instructArr[1])}</div>`;
        htmlAgreement += `<div>定位状态：${locType[instructArr[2]] || ''}</div>`;
        htmlAgreement += `<div>纬度：${this.setPositionLog(instructArr[3], 'longitude')} ${instructArr[4]}</div>`;
        htmlAgreement += `<div>经度：${this.setPositionLog(instructArr[5], 'latitude')}  ${instructArr[6]}</div>`;
        htmlAgreement += `<div>地面速度：${instructArr[7]}节(N)</div>`;
        htmlAgreement += `<div>地面航向：${instructArr[8]}度</div>`;
        const substrSet = instructArr[9];
        const agreement1 = substrSet.substr(0, 2);
        const agreement2 = substrSet.substr(2, 2);
        const agreement3 = substrSet.substr(4);
        htmlAgreement += `<div>日期：${agreement3}-${agreement2}-${agreement1}</div>`;
        htmlAgreement += `<div>磁偏角：${instructArr[10]}度</div>`;
        htmlAgreement += `<div>磁偏角方向：${instructArr[11]}</div>`;
        htmlAgreement += `<div>模式指示：${bgType[instructArr[12]] || ''}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:VTG 功能描述:输出语句，描述航迹向和地速。
    *@param {*}  格式:S--VTG,×.x,T,x.X,M,x.x,Nl,X.x,K,a*hh<CR><LF>
    *@param {*}   格式: $BDVTG,60,T,120,M,30,M/S,40,K,A,1*hh
    */
    communicationBDVTG(charCode) {
        const instructArr = charCode.split(",");
        const bgType = { 'A': "自主模式", 'B': "差分模式", 'E': "估算（航位推算）模式", 'M': "手动输入模式", 'S': "模拟器模式", 'N': "数据无效", }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：输出语句。推荐最简导航传输数据。</div>`;
        htmlAgreement += `<div>对地航向：${instructArr[1]}度</div>`;
        htmlAgreement += `<div>真北：${instructArr[2]}</div>`;
        htmlAgreement += `<div>对地航向：${instructArr[3]}度</div>`;
        htmlAgreement += `<div>磁北：${instructArr[4]}</div>`;
        htmlAgreement += `<div>对地速度：${instructArr[5]}</div>`;
        htmlAgreement += `<div>速度单位：${instructArr[6]}</div>`;
        htmlAgreement += `<div>对地速度：${instructArr[7]}</div>`;
        htmlAgreement += `<div>速度单位：${instructArr[8]}</div>`;
        htmlAgreement += `<div>模式指示器：${bgType[instructArr[9]] || ''}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:ZDA 功能描述:双向语句。描述UTC 时间、日期和本地时区。如果终端通过BDS获得时间信息，则标识符使用BD;如果通过GPS 获得时间信息，则标识符使用GP;如果同时利用BDS 和 GPS等其他系统获得时间信息，则标识符使用GN。对于定时型用户机，时间起点为$的第一比特上升沿，且与1PPS输出信号的前沿对齐误差需小于1毫秒。
    *@param {*}  格式:$--ZDA,x,hhmmss.ss,xx,Xx,xKx,Kx,xx,hhmmss.Ss,X.x,x,a*hh<CR><LF>
    *@param {*}   格式: $BDZDA,1,133745.23,29,03,2024,01,34,134021.23,12,1,Y*21
    */
    communicationBDZDA(charCode) {
        const instructArr = charCode.split(",");
        const bgType = { '0': "未监测", '1': "0~10ns", '2': "10~20ns内", '3': "大于20ns" }
        const wxType = { 'Y': "信号锁定", 'N': "信号失锁", }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：双向语句。描述UTC 时间、日期和本地时区。如果终端通过BDS获得时间信息，则标识符使用BD;如果通过GPS 获得时间信息，则标识符使用GP;如果同时利用BDS 和 GPS等其他系统获得时间信息，则标识符使用GN。对于定时型用户机，时间起点为$的第一比特上升沿，且与1PPS输出信号的前沿对齐误差需小于1毫秒。</div>`;
        htmlAgreement += `<div>模式指示：${instructArr[1] == 1 ? 'RDSS定时结果' : instructArr[1] == 2 ? 'RNSS定时结果' : instructArr[1]}</div>`;
        htmlAgreement += `<div>时间：${instructArr[2] < 0 ? `东经${this.setTimes(instructArr[1])}` : this.setTimes(instructArr[2])}</div>`;
        htmlAgreement += `<div>日期：${instructArr[5]}年 ${instructArr[4]}月 ${instructArr[3]}日 </div>`;
        htmlAgreement += `<div>本地时区：${instructArr[6]}</div>`;
        htmlAgreement += `<div>本时区分钟差：${instructArr[7]}分钟</div>`;
        const upTime = instructArr[8];
        if (upTime.length >= 6) {
            const hh = upTime.substr(0, 2) || '-';
            const mm = upTime.substr(2, 2) || '-';
            const ss = upTime.substr(4, 2) || '-';
            htmlAgreement += `<div>定时修正值时刻：${hh}:${mm}:${ss}</div>`;
        }
        htmlAgreement += `<div>修正值：${instructArr[9]}纳秒</div>`;
        htmlAgreement += `<div>精度指示：${bgType[instructArr[10]] || ''}</div>`;
        htmlAgreement += `<div>卫星信号锁定状态：${wxType[instructArr[11]] || ''}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description: TBQ 功能描述:通播类报文通信申请，输入语句，用于设置终端发送报文通信申请。
    *@param {*} 格式: $CCTBQ,X.xX,X.X,XXX,C-C,x.x*hh <CR><LF>
    *@param {*} 格式: $CCTBQ,123456,2,0,4,5,6,7,8,9,10,2,970442902AAB65E6CE8E016151BA06C3E04000179439FD36953081349439FC389439FD339530CF369439FD33,0
    */
    communicationCCTBQ(charCode) {
        const instructArr = charCode.split(",");

        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：通播类报文通信申请，输入语句，用于设置终端发送报文通信申请。</div>`;
        htmlAgreement += `<div>通播ID：${instructArr[1]}</div>`;
        htmlAgreement += `<div>频点：LF${instructArr[2]}</div>`;
        htmlAgreement += `<div>区域标示：${instructArr[3] == 0 ? '区域' : '全球'}</div>`;
        if (instructArr[3] == 0) {
            htmlAgreement += `<div>卫星号：${instructArr[4]}</div>`;
            htmlAgreement += `<div>波束号：${instructArr[5]}</div>`;
        }
        if (instructArr[3] == 1) {
            htmlAgreement += `<div>出站范围中心经度：${instructArr[6]} ${instructArr[7]}</div>`;
            htmlAgreement += `<div>出站范围中心纬度：${instructArr[8]} ${instructArr[9]}</div>`;
            htmlAgreement += `<div>出站范围半径：${instructArr[10]}</div>`;
        }
        htmlAgreement += `<div>编码类别：${this.codingType[instructArr[11]]}</div>`;
        if (instructArr[11] == 3) {
            const set = instructArr[12].substr(2);//  说明 信息
            htmlAgreement += `<div>通信数据：${GB18030StringZh(set)}</div>`;
        } else {
            htmlAgreement += `<div>通信数据：</div>`;
            htmlAgreement += tdwtClass.communicationData(instructArr[12], instructArr[11]);
        }
        htmlAgreement += `<div>报文通信频度：${instructArr[13] == 0 ? '单次' : `${instructArr[13]}秒`}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:BSI 功能描述:输出语句。用户设备捕获跟踪BD-2GEO卫星信号后，通过数据接口输出捕获跟踪波束的状态。
    *@param {*}   格式:$--BSI,xx,xx,X.X,…X.x*hh<CR><LF>
    *@param {*}   格式: $BDBSI,1,10,20,30,40*hh
    */
    communicationBDBSI(charCode) {
        const instructArr = charCode.split(",");
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：输出语句。用户设备捕获跟踪BD-2GEO卫星信号后，通过数据接口输出捕获跟踪波束的状态。</div>`;
        htmlAgreement += `<div>响应波束号：${instructArr[1]}</div>`;
        htmlAgreement += `<div>时差波束号：${instructArr[2]}</div>`;
        for (let index = 3; index < instructArr.length; index++) {
            htmlAgreement += `<div>${index - 2}号波束信号功率：${instructArr[index]} </div>`;
        }
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:DWR 功能描述:输出语句。用户设备接收到定位信息，或具备指挥功能的用户设备发送查询下属”用户定位信息后接收到的定位信息，或用户设备接收到的位置报告信息。
    *@param {*}   格式: 格式:$--DWR,x,xxxxxxx,hhmmss.ss,1l1!.il,a.yyyyy.yy,a,x.x,U,x.x,U,x,A,A,a*hh<CR><LF>
    *@param {*}   格式: $BDDWR,3,4207782,091212.01,2312.02,N,11323.03,E,20,M,32,M,O,V,A,L*21
    */
    communicationBDDWR(charCode) {
        const instructArr = charCode.split(",");
        const bdType = { 1: "本用户设备进行定位申请返回的定位信息", 2: "具备指挥功能的用户设备进行定位查询返回的下属用户位置信息", 3: "接收到位置报告的定位信息" }
        const logType = { 1: "用户地址为本设备用户地址", 2: "用户地址为被查询用户的用户地址", 3: "用户地址为发送位置报告方的用户地址" }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：输出语句。用户设备捕获跟踪BD-2GEO卫星信号后，通过数据接口输出捕获跟踪波束的状态。</div>`;
        htmlAgreement += `<div>定位信息类型：${bdType[instructArr[1]] || ''}</div>`;
        htmlAgreement += `<div>用户地址(ID号）：${instructArr[2]} </div>`;
        htmlAgreement += `<div>用户地址类型：${logType[instructArr[1]] || ''}  </div>`;
        htmlAgreement += `<div>定位时刻(UTC时间)： ${this.setTimes(instructArr[3])}</div>`;
        htmlAgreement += `<div>纬度：${this.setPositionLog(instructArr[4], 'longitude')}  ${instructArr[5]}</div>`;
        htmlAgreement += `<div>经度：${this.setPositionLog(instructArr[6], 'latitude')} ${instructArr[7]}</div>`;

        htmlAgreement += `<div>大地高：${instructArr[8]}</div>`;
        htmlAgreement += `<div>大地高单位：${instructArr[9]}</div>`;
        htmlAgreement += `<div>高程异常：${instructArr[10]}</div>`;
        htmlAgreement += `<div>高程异常单位：${instructArr[11]}</div>`;
        htmlAgreement += `<div>精度指示：${instructArr[12] == 0 ? '一档定位精度为20米' : '二档定位精度为100米'}</div>`;
        htmlAgreement += `<div>紧急定位指示：${instructArr[13] == 'A' ? '紧急定位' : '非紧急定位'}</div>`;
        htmlAgreement += `<div>多值解指示：${instructArr[14] == 'A' ? '多值解' : '非多值解'}</div>`;
        htmlAgreement += `<div>紧急定位指示：${instructArr[15] == 'H' ? '高空' : '普通'}</div>`;

        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:FKI 功能描述:功能描述:输出语句。用户设备输出的反馈信息。
    *@param {*}   格式:$--FKI,ccc,a,a,x,hhss*hh<CR><LF>
    *@param {*}   格式: $BDFKI,123456,Y,Y,2,,    $BDFKI,025659,QRQ,Y,0,0021*4C
    */
    communicationBDFKI(charCode) {
        const instructArr = charCode.split(",");
        const rzsType = { 'EPQ': "应急搜救与定位报告", 'TCQ': "报文通信申请", 'QRQ': "查询功能", 'DTQ': "定时申请", 'OFQ': "开关机报告", 'MSQ': "静默申请", 'GBQ': "建组申请" }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        if (rzsType[instructArr[2]]) {
            const errType = { '1': "频率未到", '2': "发射抑制", '3': "发射静默", '4': "功率未锁定", '5': "未检测到IC模块信息", '6': "权限不足" }
            htmlAgreement += `<div class="mb_10">功能描述：发射申请反馈状态，输出语句。设备向用户反馈入站发射类型，成功与否状态及原因等。</div>`;
            htmlAgreement += `<div>指令执行时间：${this.setTimes(instructArr[1])}</div>`;
            htmlAgreement += `<div>入站发射类型：${rzsType[instructArr[2]] || ''}</div>`;
            htmlAgreement += `<div>发射情况：${instructArr[3] == 'Y' ? '发射成功' : '发射失败'}</div>`;
            htmlAgreement += `<div>失败原因：${errType[instructArr[4]] || ''}</div>`;
            if (instructArr[5] && instructArr[5] != '0000' && Number(instructArr[5]) != 0) {
                htmlAgreement += `<div>等待时间：${instructArr[5] == '0000' ? '' : Number(instructArr[5])}秒</div>`;
            } else {
                htmlAgreement += `<div>等待时间：0</div>`;
            }
        } else {
            const bdType = { 0: "发射抑制解除", 1: "接收到系统的抑制指令，发射被抑制", 2: "电量不足，发射被抑制", 3: "设置为无线电静默，发射被抑制" }
            htmlAgreement += `<div class="mb_10">功能描述：功能描述:输出语句。用户设备输出的反馈信息。</div>`;
            htmlAgreement += `<div>指令名称：${instructArr[1]}</div>`;
            htmlAgreement += `<div>指令执行情况：${instructArr[2] == 'Y' ? '指令执行成功' : '指令执行失败'}</div>`;
            htmlAgreement += `<div>频度设置指示：${instructArr[3] == 'Y' ? '成功' : '频度设置错误'}</div>`;
            htmlAgreement += `<div>发射抑制指示：${bdType[instructArr[4]] || ''}</div>`;
            if (instructArr[5] && instructArr[5] != '0000') {
                htmlAgreement += `<div>等待时间：${instructArr[5] == '0000' ? '' : `${Number(instructArr[5])}秒`}</div>`;
            } else {
                htmlAgreement += `<div>等待时间：0</div>`;
            }
        }
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:HZR 功能描述:输出语句。用户设备进行通信回执查询后的获得的回执信息 格式:$--HZR,Xxxxxxx,x,hhmm,hhmm,…-,hhmm,hhmn*hh<CR><LF>
    *@param {*}   格式:$--HZR,Xxxxxxx,x,hhmm,hhmm,…-,hhmm,hhmn*hh<CR><LF>
    *@param {*}   格式: $BDHZR,123456,2,10:10,11:11,12:12,13:13
    */
    communicationBDHZR(charCode) {
        const instructArr = charCode.split(",");
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：输出语句。用户设备进行通信回执查询后的获得的回执信息。</div>`;
        htmlAgreement += `<div>用户地址(ID号)：${instructArr[1]}</div>`;
        htmlAgreement += `<div>回执数：${instructArr[2] == 0 ? '无回执' : instructArr[2]}</div>`;

        for (let index = 0; index < instructArr[2]; index++) {
            const element = accAdd(3, accMul(index, 2))
            htmlAgreement += `<div class="mb_10">回执${index + 1} 发信时间： ${this.setTimes(element)}</div>`;
            htmlAgreement += `<div class="mb_10">回执${index + 1} 回执时间：  ${this.setTimes(element + 1)}</div>`;
        }

        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:ICI 功能描述:功能描述:输出语句。用户设备输出本机加解密模块的信息。
    *@param {*}  格式:$--ICI,xxxxxxx,xxxXXxXx,xXXXXXX,X,X.X,X,a,X.x*hh<CR><LF>
    *@param {*}   格式: $BDICI,123456,1654321,0,1,2,2,E,0
    */
    communicationBDICI(charCode) {
        const instructArr = charCode.split(",");
        const bdType = {
            0: "指挥型用户机",
            1: "一类用户机",
            2: "二类用户机",
            3: "三类用户机",
            4: "指挥型用户机(进行身份认证)",
            5: "一类用户机(进行身份认证)",
            6: "二类用户机(进行身份认证)",
            7: "三类用户机(进行身份认证)",
        }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：输出语句。用户设备进行通信回执查询后的获得的回执信息。</div>`;
        htmlAgreement += `<div>用户地址(ID号)：${instructArr[1]}</div>`;
        htmlAgreement += `<div>序列号：${instructArr[2]}</div>`;
        htmlAgreement += `<div>通播地址：${instructArr[3]}</div>`;
        htmlAgreement += `<div>用户特征值：${bdType[instructArr[4]] || ''}</div>`;
        htmlAgreement += `<div>服务频度：${instructArr[5]}秒</div>`;
        htmlAgreement += `<div>通信等级：${instructArr[6]}</div>`;
        htmlAgreement += `<div>加密标志：${instructArr[7] == 'E' ? '加密' : '非密'}</div>`;
        htmlAgreement += `<div>下属用户数：${instructArr[8]}</div>`;
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:ICZ 功能描述:输出语句。指挥型用户设备输出下属用户信息。除最后一条语句外，其余每条必须传满40个用户信息。
    *@param {*}  格―式:$--ICZ,xX,xxxxXxx,xxXxxxX,......xxxxxxx*hh<CR><LF>
    *@param {*}   格式: $BDICZ,2,1,2
    */
    communicationBDICZ2(charCode) {
        const instructArr = charCode.split(",");
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：输出语句。指挥型用户设备输出下属用户信息。</div>`;
        htmlAgreement += `<div>总下属用户数：${instructArr[1]}</div>`;
        for (let index = 0; index < instructArr[1]; index++) {
            const element = array[index];
            htmlAgreement += `<div class="mb_10">下属用户ID号：${instructArr[element]}</div>`;
        }
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:TXR 功能描述:输出语句。用户设备进行通信申请后获得的通信信息。
    *@param {*}  格-式:$--TXR,X,xXxxxxx,x,hhmm,c--c*hh<CR><LF>
    *@param {*}   格式:  $BDTXR,4,4207748,2,1201,A4313233313333*21
    */
    communicationBDTXR(charCode) {
        const instructArr = charCode.split(",");
        const bdType = {
            1: "普通通信",
            2: "特快通信",
            3: "通播通信",
            4: "按最新存入电文查询获得的通信",
            5: "按发信方地址查询获得的通信",
        }
        const bWType = {
            0: "汉字",
            1: "代码",
            2: "混合传输",
        }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：输出语句。指挥型用户设备输出下属用户信息。</div>`;
        htmlAgreement += `<div>信息类别：${bdType[instructArr[1]] || ''}</div>`;
        htmlAgreement += `<div>用户地址（ID号)：${instructArr[2]}</div>`;
        htmlAgreement += `<div>电文形式：${bWType[instructArr[3]] || ''}</div>`;
        if (instructArr[1] == 4 || instructArr[1] == 5) {
            htmlAgreement += `<div>发信时间：${this.setTimes(instructArr[4])}</div>`;
        }
        if (instructArr[3] == 0) {
            htmlAgreement += `<div>通信电文内容：${instructArr[5]}</div>`;
        }
        if (instructArr[3] == 1) {
            htmlAgreement += `<div>通信电文内容：${GB18030StringZh(instructArr[5])}</div>`;
        }
        if (instructArr[3] == 2) {
            const set = instructArr[5].substr(2);//  说明 信息
            htmlAgreement += `<div>通信电文内容：${GB18030StringZh(set)}</div>`;
        }
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
   *@description:TXA 功能描述:输入语句。用于设置用户设备发送通信申请。
   *@param {*}  格式:$--TXA,xxxxxxx,x,X,C--c*hh<CR><LF>
   *@param {*}   格式:  $CCTXA,4207748,1,2,A4313233313333*21
   */
    communicationCCTXA(charCode) {
        const instructArr = charCode.split(",");
        const bdType = {
            0: "特快通信",
            1: "普通通信",
        }
        const bWType = {
            0: "汉字",
            1: "代码",
            2: "混合传输",
        }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：输入语句。用于设置用户设备发送通信申请。</div>`;
        htmlAgreement += `<div>用户地址（ID号)：${instructArr[1]}</div>`;
        htmlAgreement += `<div>信息类别：${bdType[instructArr[2]] || ''}</div>`;
        htmlAgreement += `<div>电文形式：${bWType[instructArr[3]] || ''}</div>`;
        if (instructArr[3] == 0) {
            htmlAgreement += `<div>通信电文内容：${instructArr[4]}</div>`;
        }
        if (instructArr[3] == 1) {
            htmlAgreement += `<div>通信电文内容：${GB18030StringZh(instructArr[4])}</div>`;
        }
        if (instructArr[3] == 2) {
            const set = instructArr[4].substr(2);//  说明 信息
            htmlAgreement += `<div>通信电文内容：${GB18030StringZh(set)}</div>`;
        }
        htmlAgreement += `</div>`;
        return htmlAgreement
    }
    /**
    *@description:WAA 双向语句。用于设置用户设备发送位置报告1申请(即用户设备通过RNSS系统获得自身位置后，通过 RDSS 链路向指定用户发送位置数据)，或用户设备接收到的位置报告信息。本语句不适用于指挥型用户设备监收的位置信息输出。
    *@param {*}   格式:$--WAA,x,x.x,xxxxxxx,hhmmss.ss,111.11,a,yyyyy.yy,a,x.x,U*hh<CR><LF>
    *@param {*}   格式: $CCWAA,1,12,0248111,081637.00,2604.65334,N,11916.15000,E,43,M*30
    */
    communicationBDWAACCWAA(charCode) {
        const instructArr = charCode.split(",");
        const bdType = {
            0: "表示该位置信息为用户设备接收的位置报告信息",
            1: "表示该位置信息为用户设备发送的位置报告信息",
        }
        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：输出语句。指挥型用户设备输出下属用户信息。</div>`;
        htmlAgreement += `<div>信息类型：${bdType[instructArr[1]] || ''}</div>`;
        htmlAgreement += `<div>报告频度：${instructArr[2] == 0 ? '单次' : `${parseInt(instructArr[2], 10)}秒`}</div>`;
        htmlAgreement += `<div>用户地址（ID号)：${instructArr[3]}</div>`;
        htmlAgreement += `<div>位置报告时间：${this.setTimes(instructArr[4])}</div>`;
        htmlAgreement += `<div>纬度：${this.setPositionLog(instructArr[5], 'longitude')} 纬度方向：${instructArr[6]}</div>`;
        htmlAgreement += `<div>经度：${this.setPositionLog(instructArr[7], 'latitude')} 经度方向：${instructArr[8]}</div>`;
        htmlAgreement += `<div>高程值：${instructArr[9]}</div>`;
        htmlAgreement += `<div>高程单位：${instructArr[10]}</div>`;

        htmlAgreement += `</div>`;
        return htmlAgreement
    }

    /**
    *@description:TCI 功能描述:报文通信信息，输出语句。终端收到报文通信信息。
    *@param {*}   格式:$BDTCI,×.x,x,hhmmss,x,x,c-c*hh <CR><LF>
    *@param {*}   格式: $BDTCI,4207745,4207781,2,095123,2,0,93000690259E6699C69606C3DDF40161541E0033C2E9B7B3B8F7CEBBB6D3D3D1B1A8D2BBCFC2D7D4BCBAB5C4CEBBD6C3*3B
    */
    communicationBDTCI(charCode) {
        const instructArr = charCode.split(",");
        const bdType = {
            1: "S1",
            2: "S2C",
            3: "预留",
            3: "B2b",
        }

        let htmlAgreement = `<div class="ml_20 mb_10">`;
        htmlAgreement += `<div class="mb_10">功能描述：报文通信信息，输出语句。终端收到报文通信信息。</div>`;
        htmlAgreement += `<div>发信方ID：${instructArr[1]}</div>`;
        htmlAgreement += `<div>收信方ID：${instructArr[2]}</div>`;
        htmlAgreement += `<div>频点：${bdType[instructArr[3]] || ''}</div>`;
        htmlAgreement += `<div>时间：${this.setTimes(instructArr[4])}</div>`;
        htmlAgreement += `<div>编码类别：${this.codingType[instructArr[5]]}</div>`;
        htmlAgreement += `<div>数据标识：${instructArr[6] == 1 ? '邮箱' : '即时'}</div>`;
        htmlAgreement += `<div>通信数据：</div>`;
        htmlAgreement += tdwtClass.communicationData(instructArr[7], instructArr[5]);

        htmlAgreement += `</div>`;
        return htmlAgreement
    }
}
const bd3Proxyg = new bd3Class();
export default bd3Proxyg;
